import React from 'react';
import { updateLocation, updateResponse, getAllBranches, getStateProvinces, getLocation } from "../../api/locationApi";
import { getBranch } from "../../api/branchapi";
import {
    Form,
    Label, Input,
    Button, Col, Row
} from 'reactstrap';
import { Redirect } from "react-router-dom";
import { connect } from 'react-redux';
import { formatEditDate, formatDateFields, formatInTimeZoneDate, formatInTimeZoneDateTime } from '../../helpers';
import { getPermission } from '../../api/userapi';
import CustomDatePicker from '../CustomDatePicker';
import CardTitle from '../CardTitle';
import PopupError from '../PopupError';
import FormValidator from '../FormValidation';
import '../css/EditCreate.css';
import cloneDeep from 'lodash/cloneDeep';
import InputTag from '../InputTag';
import RequiredFieldNotation from '../utils/RequiredFieldNotation';
import feedback from '../utils/feedback';
import InputFeedback from '../utils/InputFeedback';

class LocationEdit extends React.Component {

    constructor(props) {
        super(props);
        this.permission = getPermission()
        this.props.route.history.push('/secure/locations');
        this.props.route.history.push(this.props.route.match.url);
        this.validator = new FormValidator([
            {
                field: 'city',
                method: 'isEmpty',
                validWhen: false,
                message: 'Value is required.'
            },
            {
                field: 'stateProvinceState',
                method: 'isEmpty',
                validWhen: false,
                message: 'Value is required.'
            },
            {
                field: 'branchName',
                method: 'isEmpty',
                validWhen: false,
                message: 'Value is required.'
            },
            {
                field: 'startDate',
                method: this.isBefore,
                validWhen: true,
                message: 'Start date must be before end date.'
            }
        ]);

        let location = null;
        if (this.props.route.location.state)
            if (this.props.route.location.state.location)
                location = this.props.route.location.state.location;
        this.state = {
            readOnly: true,
            location: location,
            cancel: false,
            saved: false,
            error: false,
            edit: false,
            errorMessage: [],
            validation: this.validator.valid(),
            baseState: '',
            branches: [],
            branchIanaTimeZoneId: '',
            locationId: this.props.route.match.params.locationId ? this.props.route.match.params.locationId : '',
            stateProvinces: []
        }
        this.onArrayChange = this.onArrayChange.bind(this);
        this.closeModal = this.closeModal.bind(this);
    }

    onArrayChange(newSynonym) { this.setState(prev => prev.location.synonyms = newSynonym); }

    isBefore = (confirmation, state) => (state.endDate >= confirmation || !state.endDate);
    isAfter = (confirmation, state) => (state.startDate <= confirmation);

    //Removes the readonly attribute on edit and hides edit button / save and cancel buttons appear
    handleEdit() {
        this.setState(state => ({
            readOnly: !state.readOnly,
            edit: true
        }));

    }

    closeModal() {
        this.setState({ error: false });
        this.submitted = false;
    }

    componentDidMount() {
        // Location can be brought by the list, by params in the URL or from the create location.
        //If it's not from the list, call API with the id
        if (this.state.location == null) {
            const locationId = this.props.route.match.params.locationId;
            this.props.getLocationConnect(function (result, _this) { _this.getDataLocation(result, _this) }, this, locationId)
            //If it's brought by the list, cloneDeep it and save the basestate for cancelling
        } else if (this.props.route.location.state.location) {
            var x = JSON.stringify(cloneDeep(this.props.route.location.state.location));
            this.setState({
                baseState: x,
                loading: true,
            });
            //If it's brought by the create, call API with the locationID in props.location
        } else if (this.props.location.state.locationId) {
            this.props.getLocationConnect(function (result, _this) { _this.getDataLocation(result, _this) }, this, this.state.locationId)
        }
        //Get the branches and stateprovinces for the options
        this.props.getAllBranches(function (result, _this) { _this.getData(result, _this) }, this);
        this.props.getStateProvinces(function (result, _this) { _this.getDataStates(result, _this) }, this);
        if (this.state.location != null) {
            this.props.getBranch(function (result, _this) { _this.getDataBranch(result, _this) }, this, this.state.location.branchId)
        }
    }

    getDataLocation(data, _this) {
        var x = JSON.stringify(cloneDeep(data.data.data));
        _this.setState({
            location: data.data.data,
            baseState: x,
            branchIanaTimeZoneId: data.data.data.branchIanaTimeZoneId,
            _startDate: !data.data.data.startDate ? '' : formatInTimeZoneDate(data.data.data.startDate, data.data.data.branchIanaTimeZoneId),
            _endDate: !data.data.data.endDate ? '' : formatInTimeZoneDate(data.data.data.endDate, data.data.data.branchIanaTimeZoneId)
        })
    }

    //Shows options of array of branch names. Saves branchId in "id" attribute so we can save branchId state in form.
    renderBranchNames() {
        return this.state.branches.map((branch, index) => {
            return (
                <option id={branch.branchId} key={index}>{branch.name}</option>
            );
        });
    }

    //Shows options of array of state names. Saves stateProvinceId in "id" attribute so we can save StateProvinceId state in form.
    renderStateProvinces() {
        return this.state.stateProvinces.map((stateProvince, index) => {
            return (
                <option id={stateProvince.stateProvinceId} key={index}>{stateProvince.state}</option>
            );
        });
    }

    getData(data, _this) {
        _this.setState({
            branches: data.data.data,
            loading: false
        })
    }

    getDataBranch(data, _this) {
        _this.setState({
            branchIanaTimeZoneId: data.data.data.branchIanaTimeZoneId,
            _startDate: !_this.state.location.startDate ? '' : formatInTimeZoneDate(_this.state.location.startDate, data.data.data.branchIanaTimeZoneId),
            _endDate: !_this.state.location.endDate ? '' : formatInTimeZoneDate(_this.state.location.endDate, data.data.data.branchIanaTimeZoneId),
            loading: false
        })
    }

    getDataStates(data, _this) {
        _this.setState({
            stateProvinces: data.data.data,
            loading: false
        })
    }

    //Redirects to club list
    handleCancel = () => {
        if (this.state.edit) {
            this.setState(state => ({
                location: JSON.parse(state.baseState),
                edit: false,
                readOnly: !state.readOnly,
                //sets validation to previous state
                validation: this.validator.valid()
            }))

            document.getElementById("startDate").value = !this.state.location.startDate ? "" : this.state.location.startDate.substring(0, 10);
            document.getElementById("endDate").value = !this.state.location.endDate ? "" : this.state.location.endDate.substring(0, 10);

            this.submitted = false;
            //Removes the is-invalid class from all inputs when editing is canceled
            var els = document.getElementsByClassName('is-invalid')
            while (els[0]) {
                els[0].classList.remove('is-invalid')
            }
        } else {
            this.setState({
                cancel: true
            })
        }
    }

    componentDidUpdate(prevProps) {
        //Checks if there is a response on update
        if (this.props.updateResult !== prevProps.updateResult) {
            var result = this.props.updateResult
            //Checks if the response is success or has errors.
            if (result) {
                if (result.data.success) {
                    console.log("saved");
                    var x = JSON.stringify(cloneDeep(this.state.location));
                    this.setState(state => ({
                        baseState: x,
                        saved: true,
                        edit: false,
                        readOnly: !state.readOnly,
                        validation: this.validator.valid(),
                        _startDate: !state.location.startDate ? '' : formatInTimeZoneDate(state.location.startDate + "T00:00:00", this.state.branchIanaTimeZoneId),
                        _endDate: !state.location.endDate ? '' : formatInTimeZoneDate(state.location.endDate + "T00:00:00", this.state.branchIanaTimeZoneId)
                    }));

                    //When saving is success, it brings the saved results again for updating footer.
                    this.props.getLocationConnect(function (result, _this) { _this.getDataLocation(result, _this) }, this, this.state.location.locationId)

                } else if (result.data.success === false) {
                    var errorList = [];
                    result.data.errors.map(function (e) { errorList.push(e.message) })
                    this.setState({ error: true, errorMessage: errorList })
                } else {
                    let message = Object.keys(result.data.errors).map((function (e) { return 'there was an error saving ' + e }));
                    this.setState({ error: true, errorMessage: message });
                }
                this.props.updateResponse("");
            }
        }
    }

    //Calls API for updating club on form submit
    handleSubmit = event => {
        event.preventDefault();

        var updVal = this.state.location;
        updVal.city = updVal.city.trim();
        updVal.startDate = document.getElementById("startDate").value;
        updVal.endDate = document.getElementById("endDate").value;
        this.setState({ location: updVal }, () => {
            const validation = this.validator.validate(this.state.location);
            this.setState({ validation });
            if (validation.isValid) {
                // handle actual form submission here
                this.props.updateLocation(updVal);
            }
        });
    }

    isInvalid(e) {
        var input = e.target;
        if (input.value) { input.classList.remove("is-invalid"); }
        else { input.classList.add("is-invalid"); }
    }

    render() {
        const location = this.state.location
        const branchIanaTimeZoneId = this.state.branchIanaTimeZoneId

        if (this.state.cancel) {
            return <Redirect
                to={{
                    pathname: `/secure/locations`,
                }}
            />;
        }

        let validation = this.submitted ?
            this.validator.validate(this.state.location) :
            this.state.validation;

        return (
            <div className="card">

                <CardTitle
                    component={"City"}
                    readOnly={this.state.readOnly} />

                <PopupError
                    open={this.state.error}
                    onClose={this.closeModal}
                    onClick={this.closeModal}
                    errorMessage={this.state.errorMessage}
                />

                {location && <div className="card-body fs-12">
                    <Form onSubmit={this.handleSubmit}>
                        <RequiredFieldNotation />
                        <div className="row">
                            <div className="col-md-6">
                                <Row>
                                    <div className="col-md-8">
                                        <Col className={`${validation.city.isInvalid && this.submitted ? 'has-error' : ''}`}>
                                            <Label htmlFor='city' className="required-hint mt-4"><strong>City</strong></Label>
                                            <Input
                                                id="city"
                                                readOnly={this.state.readOnly}
                                                type="input"
                                                name="city"
                                                className={this.state.readOnly ? '' : 'input-editable'}
                                                maxLength="150"
                                                required={this.submitted}
                                                value={location.city}
                                                onChange={(e) => { this.isInvalid(e); var x = location; x.city = e.target.value; this.setState({ location: x }) }} />
                                            <span className="help-block">{validation.city.message}</span>
                                        </Col>
                                    </div>
                                    <div className="col-md-4">
                                        <Col className={`${validation.stateProvinceState.isInvalid && this.submitted ? 'has-error' : ''}`}>
                                            <Label htmlFor='stateProvinceState' className="required-hint mt-4"><strong>State</strong></Label>
                                            <label className={this.state.readOnly ? 'select-disabled md-input' : 'select md-input'}>
                                                <select
                                                    id="stateProvinceState"
                                                    disabled={this.state.readOnly}
                                                    name="stateProvinceState"
                                                    className={this.state.readOnly ? 'form-control' : 'input-editable form-control'}
                                                    value={location.stateProvinceState}
                                                    onChange={(e) => {
                                                        let x = this.state.location; x.stateProvinceState = e.target.value;
                                                        let y = this.state.location; y.stateProvinceId = e.target[e.target.selectedIndex].getAttribute('id');
                                                        this.setState({ location: x, location: y })
                                                    }}
                                                >
                                                    {this.renderStateProvinces()}
                                                </select>
                                            </label>
                                            <span className="help-block">{validation.stateProvinceState.message}</span>
                                        </Col>
                                    </div>
                                </Row>
                                <Col className={this.state.readOnly ? "location-view" : ""}>
                                    <Label htmlFor='synonyms' className="mt-4"><strong>Synonyms</strong></Label>
                                    <InputTag id="synonyms" synonyms={this.state.location.synonyms} disabled={this.state.readOnly} onArrayChange={this.onArrayChange} />
                                </Col>

                            </div>
                            <div className="col-md-6">
                                <Row>
                                    <div className="col-md-12">
                                        <Col className={`${validation.branchName.isInvalid && this.submitted ? 'has-error' : ''}`}>
                                            <Label htmlFor='branchName' className="required-hint mt-4"><strong>Branch </strong></Label>
                                            <select
                                                id="branchName"
                                                disabled={this.state.readOnly}
                                                name="branchName"
                                                className={this.state.readOnly ? 'form-control' : 'input-editable form-control'}
                                                value={location.branchName}
                                                onChange={(e) => {
                                                    let x = this.state.location; x.branchName = e.target.value;
                                                    let y = this.state.location; y.branchId = e.target[e.target.selectedIndex].getAttribute('id');
                                                    this.setState({ location: x, location: y })
                                                }}
                                            >
                                                {this.renderBranchNames()}
                                            </select>
                                            <span className="help-block">{validation.branchName.message}</span>
                                        </Col>
                                    </div>
                                    {!this.state.readOnly && <div className="col-md-6">
                                        <Col className={`${validation.startDate.isInvalid && this.submitted ? 'has-error' : ''}`}>
                                            <Label htmlFor='startDate' className="mt-4"><strong>Start date</strong></Label>
                                            <CustomDatePicker
                                                id="startDate"
                                                readOnly={this.state.readOnly}
                                                defValue={!location.startDate ? "" : formatInTimeZoneDate(location.startDate, this.state.branchIanaTimeZoneId).substring(0, 10)}
                                                label="Start Date"
                                                overlayClass="location-datepicker-overlay"
                                            />
                                            <InputFeedback feedbackText={feedback.startDate} id='startDate' />
                                            <span className="help-block-calendar">{validation.startDate.message}</span>
                                        </Col>
                                    </div>}
                                    {!this.state.readOnly && <div className="col-md-6">
                                        <Col>
                                            <Label htmlFor='endDate' className="mt-4"><strong>End date</strong></Label>
                                            <CustomDatePicker
                                                id="endDate"
                                                readOnly={this.state.readOnly}
                                                defValue={!location.endDate ? "" : formatInTimeZoneDate(location.endDate, this.state.branchIanaTimeZoneId).substring(0, 10)}
                                                label="End Date"
                                                overlayClass="location-datepicker-overlay"
                                            />
                                        </Col>
                                    </div>}
                                    {this.state.readOnly && <div className="col-md-12">
                                        <Row>
                                            <div className={this.state.readOnly ? 'col-md-6 _startDate-s ' : "col-md-6 hide"}>
                                                <Label htmlFor='_startDate' className="mt-4"><strong>Start date</strong></Label>
                                                <Input
                                                    id="_startDate"
                                                    readOnly={true}
                                                    className=''
                                                    value={this.state._startDate}>
                                                </Input>

                                            </div>
                                            <div className={this.state.readOnly ? 'col-md-6 _endDate' : "col-md-6 hide"}>
                                                <Label htmlFor='_endDate' className="mt-4"><strong>End date</strong></Label>
                                                <Input
                                                    id="_endDate"
                                                    readOnly={true}
                                                    className=''
                                                    value={this.state._endDate}>
                                                </Input>
                                            </div>
                                        </Row>
                                    </div>}
                                    <Col>
                                        <div className="text-right float-bottom">
                                            <Button onClick={this.handleCancel.bind(this)} className="cancel-btn">CANCEL</Button>
                                            {this.permission.isAdmin &&
                                                <Button onClick={this.handleEdit.bind(this)} className={this.state.readOnly ? 'edit-btn' : 'd-none'}>EDIT</Button>}
                                            <Button onClick={this.handleSubmit.bind(this)} type="submit" color="primary" className={this.state.readOnly ? 'd-none' : 'save-btn'}>SAVE</Button>
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                        </div>
                    </Form>
                    {/* Divider */}
                    <Col>
                        <hr />
                    </Col>
                    <Col>
                        <Row>
                            <div className="col-md-1">
                                <div className="inline-label"><strong>ID</strong></div>
                                <p className="editFooterText">{location.locationId}</p>
                            </div>
                            <div className="col-md-3">
                                <div className="inline-label"><strong>Created by</strong></div>
                                <p className="font-weight-light">{location.createdBy}</p>
                            </div>
                            <div className="col-md-3">
                                <div className="inline-label"><strong>Created date</strong></div>
                                <p className="font-weight-light">{formatInTimeZoneDateTime(location.createdDate, branchIanaTimeZoneId)}</p>
                            </div>
                            <div className="col-md-2">
                                <div className="inline-label"><strong>Updated by</strong></div>
                                <p className="font-weight-light">{location.updatedBy}</p>

                            </div>
                            <div className="col-md-3">
                                <div className="inline-label"><strong>Updated date</strong></div>
                                <p className="font-weight-light">{formatInTimeZoneDateTime(location.updatedDate, branchIanaTimeZoneId)}</p>
                            </div>
                        </Row>
                    </Col>
                </div>
                }
            </div>
        );
    }
}
export default connect(
    state => {
        return {
            club: state.data.location,
            updateResult: state.data.updateResult,
            branches: state.data.branches,
            branch: state.data.branch,
            stateProvinces: state.data.stateProvinces

        }
    },
    dispatch => ({
        updateLocation: (callback, conext) => { dispatch(updateLocation(callback, conext)) },
        updateResponse: (response) => { dispatch(updateResponse(response)) },
        getAllBranches: (callback, context) => { dispatch(getAllBranches(callback, context)) },
        getBranch: (callback, context, id) => { dispatch(getBranch(callback, context, id)) },
        getStateProvinces: (callback, context) => { dispatch(getStateProvinces(callback, context)) },
        getLocationConnect: (callback, context, id) => { dispatch(getLocation(callback, context, id)) }
    }
    )
)(LocationEdit);

